import * as core from '../../../../../../../core'

import { query } from './build-table.query'

export const RESOURCE = {
  payload: {
    alias: 'build.table',
    description: 'Table view of pull requests that build against requirements',
    name: 'Build Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
